import React from "react";
import PropTypes from "prop-types";
import { FluentAvatar } from "../../../../../components/FluentUI/Fluent-Avatar";
import FluentUiIcon from "../../../../../assets/fluent-ui-icon";

const TaskGridMemberIcon = ({
  type,
  member,
  extraMembers,
  isGroup = false,
  isGroupIcon,
}) => {
  const { Name, User } = member;
  let names = !isGroup && member ? (User?.Name || Name).split(" ") : [];

  if (extraMembers > 98) {
    names = "99+";
  } else if (extraMembers <= 98) {
    names = `+${extraMembers}`;
  }

  return (
    type === "extra" ? (
      <FluentAvatar
        size={24}
        initials={names}
        className={`task-avatar task-member-extra`}
      />
    ) : (
      <div
        className={`task-avatar task-member-${type} ${isGroupIcon ? "isGroup" : ""
          }`}
      >
        <FluentAvatar
          size={24}
          name={isGroup ? Name : User?.Name || Name}
          badge={
            isGroupIcon
              ? {
                icon: (
                  <FluentUiIcon name="PeopleFilled" color="#0e700e" size={6} />
                ),
              }
              : null
          }
        />
      </div>
    )
  );
};

TaskGridMemberIcon.propTypes = {
  member: PropTypes.shape({
    Name: PropTypes.string,
    Initials: PropTypes.string,
    User: PropTypes.shape({
      Name: PropTypes.string,
      Initials: PropTypes.string,
    }),
  }).isRequired,
  isGroupIcon: PropTypes.bool,
  isGroup: PropTypes.bool,
  extraMembers: PropTypes.number,
  type: PropTypes.string,
};

export default TaskGridMemberIcon;
